import utils from '../utils';
//import customStyle from './map-style';

function init() {

	var maps = document.querySelectorAll('.google-maps-wrapper');

	if (maps.length > 0) {

		utils.forEach(maps, function (index, map) {
			
			var apiKey = JSON.parse(map.getAttribute('data-map')).api_key;

			utils.loadScript('https://maps.googleapis.com/maps/api/js?key=' + apiKey, false, function () {
				startMap(map);
			});

		});

	}
}

function startMap(map) {

	var mapDatas = JSON.parse(map.getAttribute('data-map')),
		markers = mapDatas.markers,
		zoom = 15,
		maxZoom = 16,
		bounds = new window.google.maps.LatLngBounds();

	var mapInstance = new window.google.maps.Map(map, {
		center: latLng,
		zoom,
		styles: 'terrain', //customStyle,
		disableDefaultUI: true,
	});

	mapInstance.setOptions({ maxZoom });

	var markerInstances = [];

	for (let index = 0; index < markers.length; index++) {

		var marker = markers[index],
			latitude = marker.latitude,
			longitude = marker.longitude,
			link = marker.link,
			latLng = new window.google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));

		var markerInstance = new window.google.maps.Marker({
			position: latLng,
			map: mapInstance,
			url: link, 
		});

		markerInstances.push(markerInstance);

		bounds.extend(latLng);

		markerInstances[index].addListener("click", () => {

			window.location.href = markerInstances[index].url;

		});
	}

	mapInstance.fitBounds(bounds); //centro e zoommo in automatico la mappa
}

export default { init };